var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'theme_' + _vm.theme,style:({
  '--font': _vm.isApple
    ? "'Myriad', 'Bogle', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'"
    : 'Myriad',
  '--btnColor': '#0045DB',
  '--nav-background':'#0045DB',
  '--newbtnColor':'#114BF2',
  '--bgImg':("url(" + (_vm.$img('/bg.png?v=1.0.3')) + ")"),
  '--userBg':("url(" + (_vm.$img('/user_bg.png?v=1.0.3')) + ")")
  // '--bgImg':`url(${bgImage})`,
  // '--userBg':`url(${userBg})`
}),attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }